import { Component, OnInit } from "@angular/core";
import { Page } from "../../../model/page";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/delay";

import { Router } from "@angular/router";
import { AuthService } from "../../../auth/auth.service";
import tableCols from "./part-usage.cols";
import { ToastrService } from "ngx-toastr";
import { MatDialog } from "@angular/material/dialog";
import { PartsUsageService } from "../services/parts-usage.service";
import { Title } from "@angular/platform-browser";
import { UsageReportService } from "../services/usage-report.service";
import { SortService } from "../services/sort.service";
import { CurrencyPipe } from "@angular/common";
import { TableExtensionService } from "../table-extension.service";

@Component({
  selector: "app-part-usage",
  templateUrl: "./part-usage.component.html",
  styleUrls: ["./part-usage.component.scss"],
  providers: [
    AuthService,
    PartsUsageService,
    UsageReportService,
    SortService,
    TableExtensionService,
  ],
})
export class PartUsageComponent implements OnInit {
  public page = new Page();
  public rows: Array<any>;
  public cols: Array<any>;
  public totalRecords: number;
  public reportData: any;

  public loading = false;
  public exportLoading = false;
  public reportLoaded: boolean;
  public isWorkspaceSelected: boolean;

  public viewFilters: boolean;
  public filtersApplied: boolean;
  public sortApplied: boolean;
  public sortField: string;
  public sortOrder: number;

  public dataSourceOptions = this.usageReportService.getDataSourceOptions();

  public hideTooltip = false;
  public tooltipRows: Array<any> = [];

  constructor(
    private partsUsageService: PartsUsageService,
    private usageReportService: UsageReportService,
    private sortService: SortService,
    private authService: AuthService,
    private toast: ToastrService,
    private router: Router,
    public dialog: MatDialog,
    private title: Title,
    private currencyPipe: CurrencyPipe,
    private tableExtensionService: TableExtensionService
  ) {
    this.page.pageNumber = 0;
    this.page.size = 50;
    this.title.setTitle("OES - Part Usage");
  }

  ngOnInit() {
    this.initValues();
    this.isWorkspaceSelected =
      this.authService.workspaceMasterCustomerID !== null;
    if (this.isWorkspaceSelected) {
      this.runReport();
    }
  }

  private initValues() {
    this.cols = tableCols;
    this.rows = [];
    this.reportData = {
      FROM_DATE: "",
      TO_DATE: "",
      generated: "",
      dataSource: UsageReportService.DATA_SOURCE_SD1,
    };

    this.totalRecords = 0;
    const today = new Date();
    this.page.filterParams["FROM_DATE"] = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );
    this.page.filterParams["TO_DATE"] = today;
    this.page.filterParams["dataSource"] = UsageReportService.DATA_SOURCE_SD1;

    this.viewFilters = false;
    this.filtersApplied = false;
    this.sortApplied = false;
    this.sortField = "";
    this.sortOrder = 0;

    this.loading = false;
    this.reportLoaded = false;
  }

  runReport(userClick = false) {
    if (
      this.page.filterParams["FROM_DATE"] > this.page.filterParams["TO_DATE"]
    ) {
      this.toast.error(
        "End Date for report must be after Start Date.",
        "Error"
      );
    } else {
      if (userClick) {
        this.clearFilters(false);
      }
      this.reportLoaded = false;
      this.page.pageNumber = 0;
      this.getData();
    }
  }

  getData() {
    this.setPage({ offset: this.page.pageNumber });
  }

  setPage(pageInfo) {
    this.loading = true;
    this.page.pageNumber = pageInfo.offset ? pageInfo.offset : 0;
    this.page.size = pageInfo.size ? pageInfo.size : this.page.size;

    this.partsUsageService.getDataList(this.page).subscribe(
      (result) => {
        this.rows = result.data.map((row) => {
          row["RA1_DISPLAY_NAME"] =
            row["RA1_SHIP_TO_ID"] +
            (row["RA1_SHIP_TO_ID"].trim().length > 0 ? " - " : "") +
            row["RA1_SHIP_TO_NAME"];
          row["PL1_DISPLAY_NAME"] =
            row["PL1_SHORT_CODE"] +
            (row["PL1_SHORT_CODE"].trim().length > 0 ? " - " : "") +
            row["PL1_NAME"];
          return row;
        });
        this.totalRecords = result.count;
        this.reportLoaded = true;
        this.reportData = result.reportData;
        this.dataSourceOptions = this.usageReportService.getDataSourceOptions(
          Number(result["masterCustomer"]["CU0_ALLOW_INVENTORY_MANAGEMENT"]) ===
            1,
          false
        );
        this.page.filterParams["dataSource"] =
          this.usageReportService.getDataSourceChoice(
            this.page.filterParams["dataSource"],
            this.dataSourceOptions
          );

        this.page.totalPages = result.count / this.page.size;
        this.loading = false;
        this.tooltipRows = this.getTooltipTextArray();
      },
      () => {
        this.loading = false;
        this.reportLoaded = false;
        window.dispatchEvent(new Event("resize"));
        this.toast.error("Request timed out", "Service Error");
      }
    );
  }

  buttonPress(e, col, target: any) {
    if (e.keyCode === 13) {
      this.filterChanged(col, target.value);
    }
  }

  clearFilters(callRunReport = true) {
    const keys = Object.keys(this.page.filterParams);
    for (const key of keys) {
      if (key !== "FROM_DATE" && key !== "TO_DATE" && key !== "dataSource") {
        delete this.page.filterParams[key];
      }
    }

    this.sortField = "";
    this.sortOrder = 0;

    this.viewFilters = false;
    this.filtersApplied = false;
    this.sortApplied = false;

    if (callRunReport) {
      this.runReport(); // since we want p-table component to be re-initialized, this call will reset reportLoaded variable
    }
  }

  filterChanged(col, value) {
    this.loading = true;

    if (value === undefined || value === null || value === "") {
      delete this.page.filterParams[col];
    } else {
      this.page.filterParams[col] = value;
    }
    this.filtersApplied = Object.keys(this.page.filterParams).length - 3 > 0;
    this.page.pageNumber = 0;

    this.setPage({ offset: this.page.pageNumber });
  }

  onPage($event) {
    this.setPage({
      offset: $event.first / $event.rows,
      size: $event.rows,
    });
  }

  onColumnResize(event) {
    this.tableExtensionService.onColumnResize(this.cols, event);
  }

  onSort(col) {
    if (col.sort) {
      if (this.page.filterParams.hasOwnProperty("SORT_COLUMN")) {
        if (this.page.filterParams["SORT_COLUMN"] === col.field) {
          if (this.page.filterParams["SORT_DIRECTION"] === "ASC") {
            this.page.filterParams["SORT_DIRECTION"] = "DESC";
          } else {
            this.page.filterParams["SORT_COLUMN"] = col.field;
            this.page.filterParams["SORT_DIRECTION"] = "ASC";
          }
        } else {
          this.page.filterParams["SORT_COLUMN"] = col.field;
          this.page.filterParams["SORT_DIRECTION"] = "ASC";
        }
      } else {
        this.page.filterParams["SORT_COLUMN"] = col.field;
        this.page.filterParams["SORT_DIRECTION"] = "ASC";
      }
      this.sortApplied = true;
      this.parseSort(this.page.filterParams);
      this.getData();
    }
  }

  private parseSort(filterParams) {
    const sortDetails = this.sortService.parseSort(filterParams);
    this.sortField = sortDetails.sortField;
    this.sortOrder = sortDetails.sortOrder;
  }

  exportClick() {
    this.exportLoading = true;
    this.partsUsageService.export(this.page).subscribe(
      (result) => {
        if (result.success) {
          setTimeout(() => {
            // delay to discourage hitting export multiple times
            this.exportLoading = false;
          }, 5000);
          this.toast.info(
            "Export is added to queue." +
              " Please check the File Exports to download the file once it is ready!",
            "Update",
            {
              timeOut: 6000,
            }
          );
        } else {
          this.exportLoading = false;
          this.toast.error("Error in exporting data.");
        }
      },
      () => {
        this.exportLoading = false;
        window.dispatchEvent(new Event("resize"));
        this.toast.error("Request timed out", "Service Error");
      }
    );
  }

  toggleFilterView() {
    this.viewFilters = !this.viewFilters;
  }

  onHover(e) {
    let ellipsed = e.target.offsetWidth < e.target.scrollWidth;
    this.hideTooltip = !ellipsed;
  }

  onHoverChildren(e) {
    let ellipsed =
      e.currentTarget.children[0].offsetWidth <
      e.currentTarget.children[0].scrollWidth;
    this.hideTooltip = !ellipsed;
  }

  getTooltipTextArray() {
    this.tooltipRows = [];
    this.rows.forEach((element) => {
      let newObj = JSON.parse(JSON.stringify(element));
      let currencyCols = this.cols.filter((el) => el.currency === true);

      currencyCols.forEach((col) => {
        newObj[col.field] = this.currencyPipe.transform(
          newObj[col.field],
          "USD",
          "symbol"
        );
      });

      this.tooltipRows.push(newObj);
    }, this);
    return this.tooltipRows;
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/part-usage/part-usage.component.ts